import styled from 'styled-components';
/** Mesmo padrão do drawer de idioma (`lang-drawer/style.ts`). */
export const TenantDrawerContainer = styled.div `
  display: flex;
  flex-direction: column;
  /*
   * O corpo do drawer é flex: sem isso o conteúdo manda na largura, e as
   * opções mudavam de tamanho conforme o texto exibido.
   */
  flex: 1;
  min-width: 0;
  /* 24px nas laterais: mesma coluna do título do drawer. */
  padding: 24px 24px 32px;

  .drawer-tenant_description,
  .drawer-tenant_feedback {
    font-size: var(--font-size-sm);
  }

  .drawer-tenant_body {
    flex-grow: 1;
    display: flex;
    margin-top: 24px;
    flex-direction: column;
  }
`;
//# sourceMappingURL=style.js.map